var render = function render(){var _vm=this,_c=_vm._self._c;return _c('single-line-text-input',{ref:"input",attrs:{"placeholder":_vm.$t('placeholder-type')},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }